import { render } from "./weeklyTask.vue?vue&type=template&id=16c679c9"
import script from "./weeklyTask.vue?vue&type=script&lang=js"
export * from "./weeklyTask.vue?vue&type=script&lang=js"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__